import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Step from 'book-calculator/components/Step';
import CoverFieldset from 'book-calculator/containers/CoverFieldset';

const CoverStep = ({ step }) => (
    <Step
        step={step}
        title={<FormattedMessage id="steps.cover.heading" />}
        description={<FormattedMessage id="steps.cover.description" />}
    >
        <CoverFieldset />
    </Step>
);

CoverStep.propTypes = {
    step: PropTypes.number.isRequired,
};

export default CoverStep;
